export const chartsData = {
  AreaChart: {
    xaxis: {
      name: "X-AXIS",
      data: [
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
      ],
    },
    yaxis: [
      {
        name: "CLIENT_COUNT",
        data: [0, 213, 457, 257, 1098, 378, 0, 159, 800, 0],
      },
      {
        name: "SERVER_COUNT",
        data: [110, 250, 390, 500, 999, 900, 1000, 90, 800, 0],
      },
      {
        name: "SERVER_COUNT",
        data: [110, 250, 390, 500, 0, 900, 1000, 90, 800, 0],
      },
    ],
    ytitle: [
      {
        title: {
          text: "Y-AXIS",
        },
      },
    ],
    title: "AREA CHART",
  },
  BarChart: {
    xaxis: {
      name: "X-AXIS",
      data: [
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
      ],
    },
    yaxis: [
      {
        name: "Sample Name",
        data: [50, 200, 400, 600, 800, 1000, 1200, 1400],
      },
    ],
    ytitle: [
      {
        title: {
          text: "Y-AXIS",
        },
      },
    ],
    title: "VERTICAL BAR CHART",
  },
  BarChart2: {
    xaxis: {
      name: "X-AXIS",
      data: [
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
        "Sample",
      ],
    },
    yaxis: [
      {
        name: "Sample Name",
        data: [50, 200, 400, 600, 800, 1000, 1200, 1400],
      },
    ],
    ytitle: [
      {
        title: {
          text: "Y-AXIS",
        },
      },
    ],
    title: "HORIZONTAL BAR CHART",
  },
  BoxChart: {
    data: [
      {
        data: [
          {
            x: "Actual Duration in Hours",
            y: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            goals: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      {
        data: [
          {
            x: "Actual Duration in Hours",
            y: [10, 9, 8, 6, 4, 5, 3, 2, 0],
            goals: [
              {
                value: 7,
              },
              {
                value: 3,
              },
            ],
          },
        ],
      },
    ],
    title: "BOX CHART",
  },
  BubbleChart: {
    data: [
      {
        name: "Bubble1",
        data: [
          [50, 1, 2],
          [150, 3, 4],
          [250, 5, 6],
          [350, 7, 8],
          [450, 9, 10],
          [550, 11, 12],
          [650, 13, 14],
        ],
      },
      {
        name: "Bubble2",
        data: [
          [5, 1, 2],
          [10, 3, 4],
          [20, 5, 6],
          [30, 7, 8],
          [40, 9, 10],
          [50, 11, 12],
          [60, 13, 14],
        ],
      },
    ],
    title: "BUBBLE CHART",
  },
  CandleStickChart: {
    data: [
      {
        data: [
          {
            x: "CandleStick in Hours",
            y: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            goals: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      {
        data: [
          {
            x: "CandleStick in Hours",
            y: [10, 9, 8, 6, 4, 5, 3, 2, 0],
            goals: [
              {
                value: 7,
              },
              {
                value: 3,
              },
            ],
          },
        ],
      },
    ],
    title: "CANDLESTICK CHART",
  },
  DoughnutChart: {
    data: [
      {
        labels: ["Completed", "Cancelled", "Scheduled", "Not Assigned"],
        data: [11325, 215, 3323, 3413],
      },
    ],
    title: "DOUGHNUT CHART",
  },
  FunnelChart: {
    data: [
      {
        name: "Caregiving Visit Statuses",
        data: [
          {
            x: "Completed",
            y: 4000,
          },
          {
            x: "Not Assigned",
            y: 3000,
          },
          {
            x: "Scheduled",
            y: 2000,
          },
          {
            x: "Cancelled",
            y: 1500,
          },
        ],
      },
    ],
    title: "FUNNEL CHART",
  },
  GaugeChart: {
    data: [
      {
        data: [75],
      },
    ],
    title: "GAUGE CHART",
  },
  HeatmapChart: {
    data: [
      {
        name: "Caregiver Performance Heatmap",
        data: [
          {
            x: "Robin Duncan",
            y: 3,
          },
          {
            x: "Paul Norton",
            y: 4,
          },
          {
            x: "Patricia Hernandez",
            y: 4,
          },
          {
            x: "Julie Evans",
            y: 4,
          },
          {
            x: "Jocelyn Leblanc",
            y: 4,
          },
          {
            x: "Curtis Hart",
            y: 2,
          },
          {
            x: "Chad Hunt",
            y: 4,
          },
          {
            x: "Charles Bryant",
            y: 4,
          },
          {
            x: "Michelle Gonzales",
            y: 4,
          },
          {
            x: "William Cochran",
            y: 3,
          },
          {
            x: "Brian Tapia",
            y: 4,
          },
          {
            x: "Michele White",
            y: 4,
          },
          {
            x: "Robert Fowler",
            y: 4,
          },
          {
            x: "Michael Saunders",
            y: 4,
          },
          {
            x: "Steven Carter",
            y: 4,
          },
          {
            x: "Richard Klein",
            y: 4,
          },
          {
            x: "Austin Golden",
            y: 4,
          },
          {
            x: "Emily Miller",
            y: 4,
          },
          {
            x: "Randy Dominguez",
            y: 4,
          },
          {
            x: "Tammy Dalton",
            y: 4,
          },
        ],
      },
      {
        name: "Caregiver Performance Heatmap",
        data: [
          {
            x: "Robin Duncan",
            y: 3,
          },
          {
            x: "Paul Norton",
            y: 4,
          },
          {
            x: "Patricia Hernandez",
            y: 4,
          },
          {
            x: "Julie Evans",
            y: 4,
          },
          {
            x: "Jocelyn Leblanc",
            y: 4,
          },
          {
            x: "Curtis Hart",
            y: 2,
          },
          {
            x: "Chad Hunt",
            y: 4,
          },
          {
            x: "Charles Bryant",
            y: 4,
          },
          {
            x: "Michelle Gonzales",
            y: 4,
          },
          {
            x: "William Cochran",
            y: 3,
          },
          {
            x: "Brian Tapia",
            y: 4,
          },
          {
            x: "Michele White",
            y: 4,
          },
          {
            x: "Robert Fowler",
            y: 4,
          },
          {
            x: "Michael Saunders",
            y: 4,
          },
          {
            x: "Steven Carter",
            y: 4,
          },
          {
            x: "Richard Klein",
            y: 4,
          },
          {
            x: "Austin Golden",
            y: 4,
          },
          {
            x: "Emily Miller",
            y: 4,
          },
          {
            x: "Randy Dominguez",
            y: 4,
          },
          {
            x: "Tammy Dalton",
            y: 4,
          },
        ],
      },
    ],
    title: "HEATMAP CHART",
  },
  HistogramChart: {
    data: [
      {
        data: [
          {
            name: "Caregiver Age Distribution",
            data: [
              23, 45, 61, 51, 57, 22, 26, 26, 33, 55, 45, 34, 52, 23, 61, 61,
              20, 54, 22, 54,
            ],
          },
        ],
        xaxis: "Age",
        yaxis: "Frequency",
      },
    ],
    title: "HISTOGRAM CHART",
  },
  LineChart: {
    xaxis: {
      name: "BRANCH_NAME",
      data: [
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
        "Indianapolis",
      ],
    },
    yaxis: [
      {
        name: "CLIENT_COUNT",
        data: [0, 213, 457, 257, 1098, 378, 0, 159, 800, 0],
      },
      {
        name: "SERVER_COUNT",
        data: [110, 250, 390, 500, 999, 900, 1000, 90, 800, 0],
      },
      {
        name: "SERVER_COUNT",
        data: [110, 250, 390, 500, 0, 900, 1000, 90, 800, 0],
      },
    ],
    ytitle: [
      {
        title: {
          text: "Client Count by Branch",
        },
      },
    ],
    title: "LINE CHART",
  },
  PieChart: {
    data: [
      {
        labels: ["Female", "Male", "Other"],
        data: [158, 212, 175],
      },
    ],
    title: "PIE CHART",
  },
  RadarChart: {
    data: [
      {
        labels: [
          "CG184",
          "CG255",
          "CG197",
          "CG210",
          "CG88",
          "CG211",
          "CG78",
          "CG254",
          "CG85",
          "CG91",
          "CG72",
          "CG126",
          "CG156",
          "CG74",
          "CG128",
          "CG141",
          "CG241",
          "CG217",
          "CG188",
          "CG133",
        ],
        data: [
          {
            name: "Average Performance Rating",
            data: [
              130, 130, 130, 40, 40, 40, 40, 130, 40, 40, 130, 130, 40, 130,
              130, 40, 40, 130, 130, 102,
            ],
          },
          {
            name: "Total Visits",
            data: [
              161, 198, 67, 149, 112, 154, 43, 216, 135, 9, 62, 103, 144, 63,
              90, 73, 29, 49, 180, 65,
            ],
          },
          {
            name: "Total Hours Served",
            data: [
              63, 77, 53, 79, 58, 72, 33, 86, 69, 6, 40, 41, 67, 41, 59, 57, 14,
              29, 72, 49,
            ],
          },
        ],
      },
    ],
    title: "RADAR CHART",
  },
  ScatterChart: {
    data: [
      {
        data: [
          {
            name: "Caregiver Performance vs Tenure",
            data: [
              [1, 2],
              [3, 4],
              [5, 6],
              [7, 8],
              [9, 10],
              [11, 12],
              [13, 14],
              [15, 16],
              [17, 18],
              [19, 20],
              [21, 22],
              [23, 24],
            ],
          },
          {
            name: "Caregiver Tenure",
            data: [
              [40.1, 42.5],
              [43.8, 44.2],
              [44.7, 46.9],
              [46.3, 48.6],
              [49.4, 50.2],
              [51.7, 52.9],
              [53.2, 54.8],
              [55.9, 56.1],
              [56.7, 58.4],
              [59.3, 60.7],
              [61.6, 62.3],
              [47.5, 48.1],
              [63.8, 64.2],
            ],
          },
          {
            name: "Caregiver Performance vs Experience",
            data: [
              [1, 3],
              [5, 4],
              [4, 3],
              [9, 3],
              [2, 3],
              [7, 2],
              [7, 3],
              [2, 3],
              [0, 4],
              [6, 2],
              [6, 3],
              [3, 3],
              [9, 3],
              [7, 3],
              [8, 4],
              [5, 3],
              [3, 4],
              [6, 3],
              [8, 3],
              [3, 3],
            ],
          },
        ],
      },
    ],
    title: "SCATTER CHART",
  },
  TreeMapChart: {
    data: [
      {
        data: [
          { x: "Category A", y: 40 },
          { x: "Category B", y: 25 },
          { x: "Category C", y: 15 },
          { x: "Category D", y: 20 },
        ],
      },
      {
        data: [
          { x: "Category E", y: 10 },
          { x: "Category F", y: 30 },
          { x: "Category G", y: 60 },
        ],
      },
    ],
    title: "TREEMAP CHART",
  },
};
